import { render, staticRenderFns } from "./ServiceTile.vue?vue&type=template&id=e8931d34&scoped=true&"
import script from "./ServiceTile.vue?vue&type=script&lang=js&"
export * from "./ServiceTile.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTile.vue?vue&type=style&index=0&id=e8931d34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8931d34",
  null
  
)

export default component.exports